const { default: axiosInstance } = require("utils/axios");

const getProductsMarketPlace = async (filter) => {
  try {
    const response = await axiosInstance.get("/store/marketplace", {
      params: {
        type: filter.type,
        page: filter.page,
        limit: filter.limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const getMarketplaceProductById = async (id, type = "product") => {
  try {
    const response = await axiosInstance.get(`/store/marketplace/${id}`, {
      params: {
        type: type,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const postPurchasePackage = async (data) => {
  try {
    const response = await axiosInstance.post("/manage/purchase-package", data);
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const sendProductToMarketPlace = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/manage/product-marketplace",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const getMarketplaceData = async (filter) => {
  try {
    const response = await axiosInstance.get(`/store/marketplace-all`, {
      params: {
        search: filter.search,
        sort: filter.sort,
        category_id: filter.category_id,
        car_type: filter.car_type,
        page: filter.page,
        limit: filter.limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const getMarketplaceList = async (type, filter) => {
  try {
    const response = await axiosInstance.get(`/store/marketplace-list`, {
      params: {
        type: type,
        ...filter,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const MarketPlaceAPI = {
  getProductsMarketPlace,
  getMarketplaceProductById,
  postPurchasePackage,
  sendProductToMarketPlace,
  getMarketplaceData,
  getMarketplaceList,
};

export default MarketPlaceAPI;
